const STORAGE_KEY = 'selected_examination';

export function getSelectedExamination() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function setSelectedExamination(exam) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(exam));
}

export function clearSelectedExamination() {
    localStorage.removeItem(STORAGE_KEY);
}